const getJobRun = (store) => {
  return store?.jobRun?.data;
};

const getIsJobRunLoading = (store) => {
  return store?.jobRun?.loading;
};

export { getJobRun, getIsJobRunLoading };
